module.exports = __webpack_public_path__ + "img/news.374a1279.png";